export enum RELIGIONS {
	BUDDHISM = "Buddhism",
	CHRISTIANITY = "Christianity",
	HINDUISM = "Hinduism",
	ISLAM = "Islam",
	ROMANCATHOLIC = "Roman Catholic",
	TAOISM = "Taoism",
	SIKHISM = "Sikhism",
	FREETHINKER = "Free Thinker",
	OTHERS = "Others",
}
